import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const HomeFilledIcon = props => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={26}
    viewBox="0 0 24 26"
    fill="none"
    {...props}>
    <Path
      fill="#3876AA"
      d="M8.538 2.164a5 5 0 0 1 6.924 0l6.168 5.92c.454.435.76 1.003.873 1.622.78 4.25.837 8.6.17 12.87l-.24 1.543c-.1.639-.65 1.11-1.296 1.11H15.58a1 1 0 0 1-1-1v-8.283H9.42v8.282a1 1 0 0 1-1 1H2.863c-.646 0-1.196-.47-1.296-1.109l-.24-1.543c-.667-4.27-.61-8.62.17-12.87a2.998 2.998 0 0 1 .873-1.623l6.168-5.919Z"
    />
  </Svg>
);
export default HomeFilledIcon;
